module.exports = __webpack_public_path__ + "img/2.bb32b06b.png";